import type { MapTheme } from "../../render/mapThemes";

export type { MapTheme };

export type PlayerId = "p1" | "p2";

export const UNIT_KINDS = [
  "rifleman",
  "rpgInfantry",
  "sniper",
  "lightTank",
  "heavyTank",
  "antiAir",
  "artillery",
  "rockets",
  "missiles",
  "landTransport",
  "transportCopter",
  "battleCopter",
  "fighterJet",
  "bomber",
] as const;
export type UnitKind = (typeof UNIT_KINDS)[number];

export const TILE_KINDS = [
  "plain",
  "forest",
  "mountain",
  "sea",
  "road",
  "city",
  "barracks",
  "factory",
  "base",
  "airport",
  "monument",
] as const;
export type TileKind = (typeof TILE_KINDS)[number];

export const BUILDING_TILE_KINDS = [
  "city",
  "barracks",
  "factory",
  "base",
  "airport",
  "monument",
] as const;
export type BuildingTileKind = (typeof BUILDING_TILE_KINDS)[number];

export type ProductionBuildingKind = "barracks" | "factory" | "base" | "airport";

export type TerrainOnlyTileKind = Exclude<TileKind, BuildingTileKind>;

export const VICTORY_CONDITIONS = ["rout", "capture", "monuments"] as const;
export type VictoryCondition = (typeof VICTORY_CONDITIONS)[number];

export type TileOwner = PlayerId | "neutral";
export type FacingDir = "up" | "down" | "left" | "right";

export interface Coord {
  x: number;
  y: number;
}

export interface Tile {
  kind: TileKind;
  owner?: TileOwner;
  capturePoints?: number;
}

export function isBuildingTile(kind: TileKind): kind is BuildingTileKind {
  return (BUILDING_TILE_KINDS as readonly TileKind[]).includes(kind);
}

interface UnitCargo {
  kind: UnitKind;
  hp: number;
  kills?: number;
  captures?: number;
}

export interface Unit {
  id: string;
  owner: PlayerId;
  kind: UnitKind;
  pos: Coord;

  hp: number;
  hasMoved: boolean;
  hasAttacked: boolean;
  facing: FacingDir;

  cargo?: UnitCargo;

  unloadReady?: boolean;

  kills?: number;
  captures?: number;
}

export interface GameMap {
  id: string;
  width: number;
  height: number;
  theme?: MapTheme;
  victoryConditions?: VictoryCondition[];
  captureCityTarget?: number;
  tiles: Tile[];
  startingUnits: Array<{ owner: PlayerId; kind: UnitKind; pos: Coord }>;
}
